import React, { Component } from "react";
import OCPList from "./OCPList";
class OrderList extends Component {
  render() {
    return <OCPList module="Order" entryPage="OrderEntry1" />;
  }
}

export default OrderList;
